import {
  DeleteOutlined,
  EditOutlined,
  PlusOutlined
} from '@ant-design/icons'
import { Button, Form, Space, Tooltip } from 'antd'
import dayjs from 'dayjs'
import get from 'lodash.get'
import React, { useEffect, useState } from 'react'
import { hasPermission } from '../../config-func'
import {
  ACTION_MODE,
  OPTIONS_ROLE,
  OPTIONS_STATUS_NOTIFICATION,
  PAGE_SIZE_OPTIONS
} from '../../configData'
import {
  departmentSearch,
  getNotificationManager,
  notificationDetail,
  notificationManagerAdd,
  notificationManagerUpdate,
  notificationStatus
} from '../../services/cmsservice'
import Card from '../Card'
import ModalCustom from '../common/Modal/ModalCustom'
import ModalConfirm, { showConfirm } from '../common/ModalConfirm/ModalConfirm'
import openNotification from '../common/Notification/openNotification '
import TableField from '../common/Table/TableField'
import FilterForm from './FilterForm'
import FormPost from './FormPost'
import { createCategory, createSelection, deleteSelection, getListCategory, getListSelection, updateSelection } from '../../services/selection-list-service'
import FormPostCategory from './FormPostCategory'
import Loading from '../Loading';
const SelectionManagement = () => {
  const permissions = JSON.parse(localStorage.getItem('permissions') || '[]')
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [mode, setMode] = useState(ACTION_MODE.VIEW)
  const [form] = Form.useForm()
  const [formCategory] = Form.useForm()
  const [dataSource, setDataSource] = useState([])
  const [total, setTotal] = useState(0)
  const [loading, setLoading] = useState(false)
  const [detail, setDetail] = useState()
  const [listDepartment, setListDepartment] = useState([])
  const [listCategory, setListCategory] = useState([])
  const [isModalOpenCategory, setIsModalOpenCategory] = useState(false)
  const [filters, setFilters] = useState({
    currentPage: 1,
    pageSize: 10
  })

  const handleSearch = () => {
    if (filters.currentPage === 1) {
      fetchData()
    } else {
      setFilters((prev) => ({ ...prev, currentPage: 1 }))
    }
  }
  async function fetchData() {
    setLoading(true)

    let _dataSource = []
    let _total = 0

    const params = {
      page: filters.currentPage,
      pageSize: filters.pageSize,
      category: filters.category || '',
      // code: filters.code || '',
      // status: filters.status || '',
    }

    const cleanedData = Object.fromEntries(
      Object.entries(params).filter(
        ([_, value]) => value !== '' && value !== null && value !== undefined
      )
    )

    try {
      const response = await getListSelection(cleanedData)
      _total = response?.data?.total
      _dataSource = response?.data?.list
      // }
    } catch (error) {
      openNotification('error', error?.response?.data?.message || 'Đã có lỗi xảy ra')
    } finally {
      setLoading(false)
      setTotal(_total)
      setDataSource(_dataSource)
    }
  }

  async function fetchDataCategory() {
    let _dataSource = []
    let _total = 0

    const params = {
      page: 1,
      pageSize: 1000,
    }

    const cleanedData = Object.fromEntries(
      Object.entries(params).filter(
        ([_, value]) => value !== '' && value !== null && value !== undefined
      )
    )

    try {
      const response = await getListCategory(cleanedData)
      _total = response?.data?.total
      _dataSource = response?.data?.list
      // }
    } catch (error) {
      openNotification('error', error?.response?.data?.message || 'Đã có lỗi xảy ra')
    } finally {
      setListCategory(_dataSource)
    }
  }


  useEffect(() => {
    fetchData()
  }, [filters.currentPage, filters.pageSize, filters.reset])

  useEffect(() => {
    fetchDataCategory()
  }, [])
  // -=0-=0-====================================================================================================
  // Columns for Table
  const initialColumns = [
    {
      title: 'STT',
      dataIndex: 'stt',
      key: 'stt',
      fixed: 'left',
      width: 60,
      align: 'center',
      render: (_, __, index) =>
        (filters.currentPage - 1) * filters.pageSize + index + 1
    },
    {
      title: 'Category',
      dataIndex: 'category',
      key: 'category',
      width: 150,
      render: (_, record) => {
        const category = listCategory?.find(item => item.category === record.category)
        return category?.title
      }
    },
    {
      title: 'Code',
      dataIndex: 'title',
      key: 'title',
      width: 150,
    },
    {
      title: 'Giá trị',
      dataIndex: 'value',
      key: 'value',
      width: 150,
    },
    {
      title: 'Order',
      dataIndex: 'order',
      key: 'order',
      width: 150,
    },

    // {
    //   title: 'Trạng thái',
    //   dataIndex: 'status',
    //   key: 'status',
    //   width: 150,
    //   render: (_, record, index) => {
    //     const name = OPTIONS_STATUS_NOTIFICATION.find(
    //       (n) => n.value === record.status
    //     )?.name
    //     return <span>{name}</span>
    //   }
    // },

    {
      title: 'Hành động',
      key: 'status',
      fixed: 'right',
      width: 150,
      render: (_, record) => {
        return (
          <Space size="small">
              <>
              {hasPermission('P80.2', permissions) && (
                <Tooltip title="Chỉnh sửa">
                  <Button
                    style={{ width: 32 }}
                    icon={<EditOutlined />}
                    onClick={() => {
                      setMode(ACTION_MODE.UPDATE)
                      setDetail(record)
                      setIsModalOpen(true)
                      // getDetailNotification(record.id)
                    }}
                  />
                </Tooltip>
              )}
              {hasPermission('P80.3', permissions) && (
                <Tooltip title="Xóa">
                <Button
                  style={{ width: 32 }}
                  icon={<DeleteOutlined style={{ color: 'red' }} />}
                  onClick={() =>
                    showConfirm({
                      title: 'Xác nhận xoá',
                      content: (
                        <div>
                          Bạn có chắc chắn muốn xoá selection
                          <b> {record.title}</b> không?
                        </div>
                      ),
                      onOk: () => handleDeleteSelection([record.id])
                    })
                  }
                />
              </Tooltip>
              )}
              </>
          
          </Space>
        )
      }
    }
  ]

  // Thêm sửa project
  const handleSave = async () => {
    setLoading(true)
    try {
      // Validate các trường trong form
      const values = await form.validateFields()
      // Kiểm tra nếu cả hai giá trị đều tồn tại
      const { id, ...data } = values
      const res =
        mode == ACTION_MODE.ADD
          ? await createSelection(data)
          : await updateSelection(data, id)

      form.resetFields()
      setIsModalOpen(false)
      fetchData()
      openNotification(
        'success',
        mode == ACTION_MODE.ADD
          ? 'Tạo mới selection thành công !'
          : 'Cập nhật selection thành công !'
      )
    } catch (err) {
      const errors = get(err, 'response.data.data', [])
      const errorMessages =
        errors?.map((error) => error.message).join('\n') ||
        get(err, 'response.data.message', [])
      openNotification('error', errorMessages || 'Đã có lỗi xảy ra')
    } finally {
      setLoading(false)
    }
  }

  const handleDeleteSelection = async (ids) => {
    const body = {
      ids: [ids]
    }
    setLoading(true)
    try {
      const res = await deleteSelection(ids, body || [])
      fetchData()
      openNotification('success', res.message)
    } catch (err) {
      console.error('Error creating product:', err)
      const errors = get(err, 'response.data.data', [])
      const errorMessages =
        errors?.map((error) => error.message).join('\n') ||
        get(err, 'response.data.message', [])
      openNotification('error', errorMessages || 'Đã có lỗi xảy ra')
    } finally {
      setLoading(false)
    }
  }


   // Thêm sửa project
   const handleSaveCategory = async () => {
    setLoading(true)
    try {
      // Validate các trường trong form
      const values = await formCategory.validateFields()
      // Kiểm tra nếu cả hai giá trị đều tồn tại
      const { id, ...data } = values
      const res = await createSelection({
      ...data,
      type: "CATEGORY"
      })

      formCategory.resetFields()
      setIsModalOpenCategory(false)
      fetchDataCategory()
      openNotification(
        'success',
        mode == ACTION_MODE.ADD
          ? 'Tạo mới category thành công !'
          : 'Cập nhật category thành công !'
      )
    } catch (err) {
      const errors = get(err, 'response.data.data', [])
      const errorMessages =
        errors?.map((error) => error.message).join('\n') ||
        get(err, 'response.data.message', [])
      openNotification('error', errorMessages || 'Đã có lỗi xảy ra')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div>
      <Loading loading={loading} />
      <Card className="mb-2">
        

        <FilterForm
        listCategory={listCategory}
          handleSearch={handleSearch}
          setFilters={setFilters}
          fetchData={fetchData}
        />
      </Card>

      <Card>
      <div
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'center',
            margin: '0px 50px 10px 0px',
            width: '100%'
          }}
        >
          {/* <h2 className="text-2xl font-semibold my-2">Quản lý dự án</h2> */}
          <div style={{ marginLeft: 'auto', display: 'flex', gap: '8px' }}>
            {/* <Button
              type="primary"
              key="primary"
              onClick={() => {
                setIsModalImportOpen(true)
              }}
            >
              <PlusOutlined /> Import Excel
            </Button> */}
            {hasPermission('P80.1', permissions) && (
            <Button
              type="primary"
              // htmlType="submit"
              onClick={() => {
                setIsModalOpen(true)
                setMode(ACTION_MODE.ADD)
                setDetail(null)
              }}
            >
              <PlusOutlined />
              Tạo mới Selection
            </Button>
            )}
{hasPermission('P80.4', permissions) && (
          <Button
              type="primary"
              // htmlType="submit"
              onClick={() => {
                setIsModalOpenCategory(true)
              }}
            >
              <PlusOutlined />
              Tạo mới Category
            </Button>
)}
          </div>
        </div>
        <TableField
          loading={loading}
          columns={initialColumns}
          dataSource={dataSource}
          scroll={{ x: 'max-content', y: 'calc(100vh - 400px)' }}
          className={`custom-table`}
          // locale={{
          //   emptyText: <Empty description="Không có dữ liệu" />, // Hiển thị "Không có dữ liệu" khi bảng không có dữ liệu
          //   triggerDesc: 'Sắp xếp giảm dần', // Khi click vào cột để sort giảm dần
          //   triggerAsc: 'Sắp xếp tăng dần', // Khi click vào cột để sort tăng dần
          //   cancelSort: 'Hủy sắp xếp' // Khi bỏ sắp xếp
          // }}

          // columns={
          //   filters.isDefault === 'fixed'
          //     ? columns.filter(
          //         (item) => !['calculationMethod'].includes(item.dataIndex)
          //       )
          //     : columns.filter(
          //         (item) => !['isDefault'].includes(item.dataIndex)
          //       )
          // }

          pagination={{
            current: filters.currentPage,
            pageSize: filters.pageSize,
            total: total,
            pageSizeOptions: PAGE_SIZE_OPTIONS,
            showSizeChanger: true,
            onShowSizeChange: (current, size) => {
              setFilters((prev) => ({
                ...prev,
                pageSize: size,
                currentPage: 1
              }))
            },
            onChange: (page) => {
              setFilters((prev) => ({ ...prev, currentPage: page }))
            },
            showTotal: (total, range) => `Hiển thị ${range[0]}-${range[1]} của ${total} bản ghi`,
            locale: { items_per_page: 'bản ghi / trang' }
          }}
          rowKey={(record, index) => index}
          locale={{ emptyText: 'Không có dữ liệu' }}
        />
      </Card>
      {/* Modal Thêm mới sản phẩm */}
      <ModalCustom
        title={
          mode == ACTION_MODE.UPDATE
            ? 'Chỉnh sửa selection'
            : mode == 'ADD'
            ? 'Thêm mới selection'
            : 'Xem chi tiết'
        }
        visible={isModalOpen}
        centered
        onCancel={() => {
          setIsModalOpen(false)
          form.resetFields()
        }}
        onConfirm={async () => {
          try {
            await form.validateFields() // Kiểm tra validation trước khi tiếp tục
            handleSave() // Nếu hợp lệ thì tiếp tục xử lý
          } catch (error) {
            console.log('Validation failed:', error)
          }
        }}
        confirmText={'Lưu'}
        cancelText="Đóng"
        footer={mode == 'VIEW' ? [''] : ''}
      >
        <FormPost
          form={form}
          data={detail}
          handleSearch={handleSearch}
          listDepartment={listDepartment}
          mode={mode}
          listCategory={listCategory}
        />
      </ModalCustom>

      <ModalCustom
        title={'Thêm mới category'
         
        }
        visible={isModalOpenCategory}
        centered
        onCancel={() => {
          setIsModalOpenCategory(false)
          formCategory.resetFields()
        }}
        onConfirm={async () => {
          try {
            await formCategory.validateFields() // Kiểm tra validation trước khi tiếp tục
            handleSaveCategory() // Nếu hợp lệ thì tiếp tục xử lý
          } catch (error) {
            console.log('Validation failed:', error)
          }
        }}
        confirmText={'Lưu'}
        cancelText="Đóng"
      >
        <FormPostCategory
          form={formCategory}
        />
      </ModalCustom>
      <ModalConfirm />
    </div>
  )
}

export default SelectionManagement
